import PropTypes from 'prop-types';
import {
  Button,
  Stack,
  Typography,
  Dialog,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
  IconButton,
  useMediaQuery,
  SwipeableDrawer,
  Box,
} from '@mui/material';
import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import event_cancel from '../../assets/icons/preveiw_cancel.svg';

const RadioButtonDialog = ({ heading, subtitle, open, handleCancel }) => {
  const navigate = useNavigate();
  const [value, setValue] = useState('private');

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleConfirm = () => {
    navigate(`/dashboard/events/${value}`);
    handleCancel();
  };

  const matches = useMediaQuery('(max-width:600px)');

  return (
    <>
      {matches ? (
        <SwipeableDrawer anchor="bottom" open={open} onClose={handleCancel}>
          <Stack spacing={2} p="0.5rem 1.5rem" maxHeight="400px">
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography color="primary" variant="subtitle2">
                {heading}
              </Typography>
              <IconButton onClick={handleCancel}>
                <Box component="img" src={event_cancel} />
              </IconButton>
            </Stack>
            <Stack spacing={1}>
              <Stack spacing={0.5}>
                <Typography
                  id="delete-modal-description"
                  color="primaryBlack"
                  variant="h5"
                  sx={{ fontSize: '1.25rem' }}
                >
                  {subtitle}
                </Typography>
                <FormControl>
                  <RadioGroup row aria-label="ticket-types" value={value} onChange={handleChange}>
                    <FormControlLabel value="private" control={<Radio />} label="Private Event" />
                    <FormControlLabel value="public" control={<Radio />} label="Public Event" />
                  </RadioGroup>
                </FormControl>
              </Stack>
              <Stack spacing={2} mt={2} direction="row" justifyContent="space-between">
                <Button
                  sx={{ order: { xs: -1, sm: 1 } }}
                  size="medium"
                  variant="outlined"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
                <Button size="medium" variant="contained" onClick={handleConfirm}>
                  Confirm
                </Button>
              </Stack>
            </Stack>
          </Stack>
        </SwipeableDrawer>
      ) : (
        <Dialog
          open={open}
          onClose={handleCancel}
          aria-labelledby="delete-modal-title"
          aria-describedby="delete-modal-description"
        >
          <Stack minWidth={420} spacing={3} sx={{ p: { xs: 2, md: 3 } }}>
            <Typography color="primary" variant="h4">
              {heading}
            </Typography>
            <Stack spacing={2}>
              <Typography
                id="delete-modal-description"
                color="primaryBlack"
                variant="h5"
                sx={{ fontSize: '1.25rem' }}
              >
                {subtitle}
              </Typography>
              <FormControl>
                <RadioGroup row aria-label="ticket-types" value={value} onChange={handleChange}>
                  <FormControlLabel value="private" control={<Radio />} label="Private Event" />
                  <FormControlLabel value="public" control={<Radio />} label="Public Event" />
                </RadioGroup>
              </FormControl>
            </Stack>
            <Stack spacing={2} mt={2} direction="row" justifyContent="space-between">
              <Button size="medium" variant="outlined" onClick={handleCancel}>
                Cancel
              </Button>
              <Button size="medium" variant="contained" onClick={handleConfirm}>
                Confirm
              </Button>
            </Stack>
          </Stack>
        </Dialog>
      )}
    </>
  );
};

// PropTypes for props validation
RadioButtonDialog.propTypes = {
  heading: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func.isRequired,
};

export default React.memo(RadioButtonDialog);
